import { render } from "./MorphToActionTargetField.vue?vue&type=template&id=1541f422"
import script from "./MorphToActionTargetField.vue?vue&type=script&lang=js"
export * from "./MorphToActionTargetField.vue?vue&type=script&lang=js"

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToActionTargetField.vue"]])

export default __exports__